<page-heading [title]="'integrations.webhookList.title' | translate" [description]="'integrations.webhookList.description' | translate"
  [hasBreadcrumb]="true" [breadcrumb]="breadcrumb" />

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-xs-12 col-md-6 col-lg-9 input-trend-search">
            <input type="search" #searchBox class="form-control" [placeholder]="'integrations.webhookList.searchPlaceholder' | translate"
              (keyup)="search(searchBox.value)" />
            <span class="mdi mdi-magnify search-icon ml-2"></span>
          </div>

          <div class="col-xs-12 col-md-6 col-lg-3 btn-group trend-button">
            <button class="btn btn-info fw-bold" (click)="showNewWebhook()">
              {{ 'integrations.webhookList.addButton' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (loadingContent) {
<content-loading-list />
}

@if (pager.total == 0) {
<empty-records-component [labelButton]="'integrations.webhookList.addButton' | translate" [buttonClass]="'btn btn-info fw-bold'"
  [subMessage]="'integrations.webhookList.emptySubMessage' | translate" [message]="'integrations.webhookList.emptyMessage' | translate"
  [icon]="'ri-message-3-line'" (emitEvent)="showNewWebhook()" />
}

<div class="card">
  @if(!loadingContent && pager.total > 0) {
  <div class="card-body table-responsive">
    <table class="table table-hover table-centered mb-0">
      <thead>
        <tr>
          <th class="text-primary-emphasis" style="width: 100px;">{{ 'integrations.webhookList.columnStatus' | translate }}</th>
          <th class="text-primary-emphasis" style="width: 60%;">{{ 'integrations.webhookList.columnName' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'integrations.webhookList.columnChannel' | translate }}</th>
          <th class="text-primary-emphasis" style="width: 100px;">{{ 'integrations.webhookList.columnCreatedAt' | translate }}</th>
          <th>
            <span class="sr-only"></span>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (webhook of pager.list; track $index) {
        <tr (click)="showEditWebhook(webhook._id)" style="cursor: pointer">
          <td class="table-user">
            @if (webhook.actived) {
            <span class="badge text-capitalize font-14 bg-success">{{ 'integrations.webhookList.statusActive' | translate }}</span>
            } @else {
            <span class="badge text-capitalize font-14 bg-warning">{{ 'integrations.webhookList.statusTestMode' | translate }}</span>
            }
          </td>
          <td>
            <strong class="text-truncate">{{ webhook.name }}</strong>
          </td>
          <td>
            {{ webhook.channel.name}}
          </td>
          <td>
            <span>
              {{ webhook.createdAt | timezoneDate : "DD/MM/YYYY" : getTimezoneCompanyCurrentUser() }}
            </span>
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <button class="btn btn-dropdown-list" [matMenuTriggerFor]="menu" type="button"
                (click)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()">
                <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
              </button>

              <mat-menu #menu="matMenu">
                <button mat-menu-item tabindex="0" (click)="
                    showRequestsWebhook(webhook.uuid); $event.stopPropagation()
                  ">
                  {{ 'integrations.webhookList.menuRequests' | translate }}
                </button>

                <button mat-menu-item tabindex="0" (click)="
                    showEditWebhook(webhook._id); $event.stopPropagation()
                  ">
                  {{ 'integrations.webhookList.menuEdit' | translate }}
                </button>

                <button mat-menu-item tabindex="0" (click)="delete(webhook._id); $event.stopPropagation()">
                  {{ 'integrations.webhookList.menuRemove' | translate }}
                </button>
              </mat-menu>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>

    @if (pager.total > pager.perPage) {
    <paginator [pager]="pager" (onPager)="loadPage($event)" />
    }
  </div>
  }
</div>